import { render, staticRenderFns } from "./CampaignsModal.vue?vue&type=template&id=feea08dc&scoped=true&"
import script from "./CampaignsModal.vue?vue&type=script&lang=js&"
export * from "./CampaignsModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsModal.vue?vue&type=style&index=0&id=feea08dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feea08dc",
  null
  
)

export default component.exports